(() => {
  if (window.whComponentsLoaded) return;
  window.whComponentsLoaded = true;
  const controllers = new WeakMap();
  function init(section) {
    if (controllers.has(section)) return;
    const track = section.querySelector('[data-wh-track]');
    if (!track) return;
    let timer, paused = false, hovering = false, focused = false;
    const slider = section.querySelector('[data-wh-slider]');
    const dots = [...section.querySelectorAll('[data-wh-dot]')];
    const reduced = window.matchMedia('(prefers-reduced-motion: reduce)');
    const index = () => Math.round(track.scrollLeft / Math.max(track.clientWidth, 1));
    const move = (target) => {
      const n = track.children.length;
      if (!n) return;
      track.scrollTo({left: ((target + n) % n) * track.clientWidth, behavior: reduced.matches ? 'instant' : 'smooth'});
    };
    const stop = () => { clearInterval(timer); timer = undefined; };
    const start = () => {
      stop();
      if (!slider || slider.dataset.autoplay !== 'true' || paused || hovering || focused || document.hidden || reduced.matches || track.children.length < 2) return;
      timer = setInterval(() => move(index() + 1), Number(slider.dataset.interval) || 6000);
    };
    const abort = new AbortController();
    const on = (el, event, callback) => el.addEventListener(event, callback, {signal: abort.signal});
    on(section, 'click', event => {
      const button = event.target.closest('[data-wh-scroll],[data-wh-dot],[data-wh-pause]');
      if (!button) return;
      if (button.hasAttribute('data-wh-scroll')) {
        const dir = Number(button.dataset.whScroll);
        if (slider) move(index() + dir);
        else track.scrollBy({left: dir * track.clientWidth * .85, behavior: reduced.matches ? 'instant' : 'smooth'});
        start();
      } else if (button.hasAttribute('data-wh-dot')) { move(Number(button.dataset.whDot)); start(); }
      else { paused = !paused; button.textContent = paused ? 'Play' : 'Pause'; button.setAttribute('aria-label', paused ? 'Play slideshow' : 'Pause slideshow'); start(); }
    });
    if (slider) {
      on(track, 'scroll', () => dots.forEach((d, i) => d.setAttribute('aria-pressed', String(i === index()))));
      on(track, 'keydown', e => { if (e.key === 'ArrowRight' || e.key === 'ArrowLeft') { e.preventDefault(); move(index() + (e.key === 'ArrowRight' ? 1 : -1)); } });
      on(section, 'mouseenter', () => { hovering = true; stop(); });
      on(section, 'mouseleave', () => { hovering = false; start(); });
      on(section, 'focusin', () => { focused = true; stop(); });
      on(section, 'focusout', e => { if (!section.contains(e.relatedTarget)) { focused = false; start(); } });
      on(document, 'visibilitychange', start);
      on(reduced, 'change', start);
      on(window, 'resize', () => { const active = dots.findIndex(d => d.getAttribute('aria-pressed') === 'true'); if (active >= 0) track.scrollLeft = active * track.clientWidth; });
      start();
    }
    controllers.set(section, {destroy: () => { stop(); abort.abort(); }, move, stop});
  }
  function boot(root = document) { root.querySelectorAll('.wh-section').forEach(init); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => boot()); else boot();
  document.addEventListener('shopify:section:load', e => boot(e.target));
  document.addEventListener('shopify:section:unload', e => e.target.querySelectorAll('.wh-section').forEach(s => { controllers.get(s)?.destroy(); controllers.delete(s); }));
  document.addEventListener('shopify:block:select', e => {
    const block = e.target.closest('.wh-slide');
    if (!block) return;
    const section = block.closest('.wh-section'), control = controllers.get(section);
    if (control) { control.stop(); control.move([...block.parentElement.children].indexOf(block)); }
  });
})();
